import DeleteIcon from "@mui/icons-material/Delete";
import styled from "styled-components";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import { mobile } from "../responsive";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { userRequest } from "../requestMethod";
import { decProduct } from "../redux/cartRedux";
import { useDispatch } from "react-redux";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../Components/CheckoutForm";
import "./../static/app.css";
import { Link } from "react-router-dom";
import SEO from "../Components/SEO";

const KEY = process.env.REACT_APP_STRIPE;

const Container = styled.div``;

const Wrapper = styled.div`
  padding: 20px;
  ${mobile({ padding: "0px" })}
`;
const Logo = styled.p`
  font-weight: bold;
  font-size: 1em;
  font-family: Bebas Neue;
  text-align: left;
  color: #fff !important;
  position: absolute;
  top: 1em;
  left: 1em;
`;
const LogoFull = styled.p`
  ont-weight: bold;
  font-size: 40px;
  font-family: "Bebas Neue";
  text-align: center;
  padding-left: 1em;
  color: rgb(67, 57, 250) !important;
  ${mobile({ display: "none" })}
`;

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  ${mobile({ flexDirection: "column" })}
`;

const Info = styled.div`
  flex: 1;
  flex-direction: column;
  margin: 0 3px 0 3px;
  padding: 10px;
  height: 100%;
`;

const Product = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding: 5px 0px;
  ${mobile({ flexDirection: "column" })}
`;

const ProductDetail = styled.div`
  display: flex;
`;

const Image = styled.img`
  width: 200px;
`;

const Details = styled.div`
  padding: 1em;
  display: flex;
  flex-direction: column;
  p {
    font-size: 1.5em;
  }
`;

const ProductName = styled.p`
  font-size: 1.2em;
  font-weight: 100 !important;
`;

const FlexTotal = styled.div`
  display: none;
  width: 100%;
  background-color: rgb(67, 57, 250);
  flex-direction: column;
  padding: 15% 0;
  margin-bottom: 1em;
  align-items: center;
  p {
    color: #c7c7c7;
  }
  h2 {
    color: #fff;
  }

  ${mobile({ display: "flex" })}
`;

const ProductSize = styled.span``;

const CartLine = styled.span``;

const PriceDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: left;
  margin: auto 0;
  min-width: 29%;
`;

const ProductAmountContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const ProductAmountSmall = styled.div`
  font-size: 12px;
  margin: 5px;
  ${mobile({ margin: "5px 15px" })}
`;

const ProductPrice = styled.div`
  font-size: 30px;
  font-weight: 200;
  ${mobile({ marginBottom: "20px" })}
`;

const SummaryMobile = styled.div`
  flex-direction: column;
  border: 0.5px solid lightgray;
  border-radius: 10px;
  margin: 0 1em 0 1em;
  padding: 20px;
  height: 100%;
`;

const Summary = styled.div`
  flex: 2;
  border: 0.5px solid lightgray;
  background-color: #fcfcfc;
  border-radius: 10px;
  margin: 0 1em 0 1em;
  padding: 20px;
  min-height: 100%;
  ${mobile({ display: "none" })}
`;
const SummaryRight = styled.div`
  flex: 1;
  border: 2px solid #4339fa;
  border-radius: 10px;
  margin: 0 1em 0 1em;
  padding: 20px;
  height: 100%;

  ${mobile({ border: "none" })}
`;

const SummaryTitle = styled.h1`
  font-weight: 200;
`;

const SummaryItem = styled.div`
  margin: 30px 0px;
  display: flex;
  justify-content: space-between;
  font-weight: ${(props) => props.type === "total" && "500"};
  font-size: ${(props) => props.type === "total" && "24px"};
`;

const SummaryItemText = styled.span``;

const SummaryItemPrice = styled.span``;

const stripePromise = loadStripe(KEY);
const Cart = () => {
  const [clientSecret, setClientSecret] = useState("");
  const cart = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const [show, setShow] = useState("none");
  const [info, setInfo] = useState("flex");
  const dispatch = useDispatch();
  let items = cart.products.map((product) => {
    return {
      _id: product._id,
      duration: product.duration,
      delivery: product.deliveryMethod === "delivery",
    };
  });

  useEffect(() => {
    const makeRequest = async () => {
      // Create PaymentIntent as soon as the page loads
      const res = await userRequest(user.accessToken).post(
        "/checkout/create-payment-intent",
        {
          items: items,
        }
      );

      setClientSecret(res.data.clientSecret);
    };
    makeRequest();
  }, []);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  const decQuantity = (props) => {
    const quantity = props.quantity;
    const _id = props._id;
    const price = props.price;
    if (props.quantity >= 1) {
      return dispatch(decProduct({ _id, quantity, price }));
    }
  };

  let postageTotal = cart.products.map((product) => {
    if (product.deliveryMethod === "delivery") {
      return product.postageCost;
    }
  });
  const postageSum = postageTotal
    .filter((x) => {
      return typeof x === "number"; //filter out any undefined postage values
    })
    .reduce((sum, num) => sum + num, 0);
  const toggleHidden = () => {
    setShow(show === "none" ? "flex" : "none");
  };
  const toggleInfo = () => {
    setInfo(info === "none" ? "flex" : "none");
  };
  return (
    <>
      <SEO
        title="Checkout | Rentoodle.com"
        description="View items in your cart and checkout. Rentoodle.com - the advertising platform for renting stuff"
      />
      <Container>
        <Navbar />
        <Wrapper>
          <Bottom>
            <FlexTotal>
              <Logo>
                RENTOODLE
                <sup style={{ fontSize: "0.4em", marginLeft: "0.4em" }}>®</sup>
              </Logo>
              <h2>
                {" "}
                {cart.total + postageSum < 10 && cart.total + postageSum > 0
                  ? "£10"
                  : "£" + (cart.total + postageSum).toFixed(2)}
              </h2>
              <p onClick={toggleHidden}>
                {show === "none" ? "Show order summary" : "Hide order summary"}
              </p>
            </FlexTotal>

            <SummaryMobile style={{ display: show }}>
              <SummaryTitle>
                {" "}
                {cart.total + postageSum <= 0
                  ? "Your shopping bag is empty"
                  : "Order Summary"}
              </SummaryTitle>
              <SummaryItem>
                <SummaryItemText>Subtotal</SummaryItemText>
                <SummaryItemPrice>£{cart.total?.toFixed(2)}</SummaryItemPrice>
              </SummaryItem>

              <SummaryItem>
                <SummaryItemText>Total Postage Costs</SummaryItemText>
                <SummaryItemPrice>£{postageSum?.toFixed(2)}</SummaryItemPrice>
              </SummaryItem>
              {cart.total + postageSum < 10 && cart.total + postageSum > 0 ? (
                <SummaryItem>
                  <SummaryItemText>
                    Small order fee{" "}
                    <div>
                      <br />
                      <span style={{ fontSize: "0.73em", maxWidth: "150px" }}>
                        Your order's below the £10.00 minimum amount. Add more
                        items items or extend the rental period to remove this
                        fee.
                      </span>
                    </div>
                  </SummaryItemText>
                  <SummaryItemPrice>
                    £{(10 - (cart.total + postageSum)).toFixed(2)}
                  </SummaryItemPrice>
                </SummaryItem>
              ) : (
                ""
              )}
              <SummaryItem type="total">
                <SummaryItemText>Total</SummaryItemText>
                <SummaryItemPrice>
                  {cart.total + postageSum < 10 && cart.total + postageSum > 0
                    ? "£10"
                    : "£" + (cart.total + postageSum).toFixed(2)}
                </SummaryItemPrice>
              </SummaryItem>
              <Info>
                {cart.products.map((product) => (
                  <>
                    <Product key={`${product._id}|1`}>
                      <ProductDetail>
                        <Link
                          to={`/product/${product._id}?uid=1`}
                          style={{ textDecoration: "none", color: "#000" }}
                        >
                          <Image src={product.img} />
                        </Link>
                      </ProductDetail>
                      <Link
                        to={`/product/${product._id}?uid=1`}
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        <Details>
                          <ProductName>{product.title}</ProductName>

                          <ProductSize>
                            <b>
                              {product.deliveryMethod === "collection"
                                ? "Collect on"
                                : "Delivered on"}{" "}
                            </b>
                            : {product.startDate}
                          </ProductSize>
                          <CartLine>
                            <b>Return by: </b>
                            {product.endDate}
                          </CartLine>
                        </Details>
                      </Link>

                      <PriceDetail>
                        <ProductPrice>
                          £{product.price.toFixed(2)} per day
                        </ProductPrice>
                        <ProductAmountSmall>
                          Delivery method:{" "}
                          {product.deliveryMethod === "delivery"
                            ? `${
                                product?.postageCost
                                  ? `£${product?.postageCost}`
                                  : "Free"
                              } postage`
                            : "collection"}
                        </ProductAmountSmall>

                        <ProductAmountContainer
                          onClick={() => decQuantity(product)}
                        >
                          <DeleteIcon style={{ cursor: "pointer" }} />{" "}
                          <span style={{ fontSize: "0.7em" }}>Remove</span>
                        </ProductAmountContainer>
                      </PriceDetail>
                    </Product>
                  </>
                ))}
              </Info>
            </SummaryMobile>
            {cart.total + postageSum > 0 ? (
              <SummaryRight>
                <LogoFull>
                  RENTOODLE
                  <sup style={{ fontSize: "0.4em", marginLeft: "0.4em" }}>
                    ®
                  </sup>
                </LogoFull>
                <SummaryItem>
                  {clientSecret && (
                    <Elements
                      options={options}
                      stripe={stripePromise}
                      allow="payment"
                    >
                      <CheckoutForm />
                    </Elements>
                  )}
                </SummaryItem>
              </SummaryRight>
            ) : (
              ""
            )}
            <Summary>
              <SummaryTitle>
                {" "}
                {cart.total + postageSum <= 0
                  ? "Your shopping bag is empty"
                  : "Order Summary"}
              </SummaryTitle>
              <SummaryItem>
                <SummaryItemText>Subtotal</SummaryItemText>
                <SummaryItemPrice>£{cart.total?.toFixed(2)}</SummaryItemPrice>
              </SummaryItem>

              <SummaryItem>
                <SummaryItemText>Total Postage Costs</SummaryItemText>
                <SummaryItemPrice>£{postageSum?.toFixed(2)}</SummaryItemPrice>
              </SummaryItem>
              {cart.total + postageSum < 10 && cart.total + postageSum > 0 ? (
                <SummaryItem>
                  <SummaryItemText>
                    Small order fee{" "}
                    <div>
                      <br />
                      <span style={{ fontSize: "0.73em", maxWidth: "150px" }}>
                        Your order's below the £10.00 minimum amount. Add more
                        items items or extend the rental period to remove this
                        fee.
                      </span>
                    </div>
                  </SummaryItemText>
                  <SummaryItemPrice>
                    £{(10 - (cart.total + postageSum)).toFixed(2)}
                  </SummaryItemPrice>
                </SummaryItem>
              ) : (
                ""
              )}
              <SummaryItem type="total">
                <SummaryItemText>Total</SummaryItemText>
                <SummaryItemPrice>
                  {cart.total + postageSum < 10 && cart.total + postageSum > 0
                    ? "£10"
                    : "£" + (cart.total + postageSum).toFixed(2)}
                </SummaryItemPrice>
              </SummaryItem>
              {/* <div style={{ cursor: "pointer" }} onClick={toggleInfo}>
                <p>
                  {info === "none"
                    ? "Show order summary"
                    : "Hide order summary"}
                </p>
              </div> */}
              <Info style={{ display: info }}>
                {cart.products.map((product) => (
                  <>
                    <Product key={`${product._id}|1`}>
                      <ProductDetail>
                        <Link
                          to={`/product/${product._id}?uid=1`}
                          style={{ textDecoration: "none", color: "#000" }}
                        >
                          <Image src={product.img} />
                        </Link>
                      </ProductDetail>
                      <Link
                        to={`/product/${product._id}?uid=1`}
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        <Details>
                          <ProductName>{product.title}</ProductName>

                          <ProductSize>
                            <b>
                              {product.deliveryMethod === "collection"
                                ? "Collect on"
                                : "Delivered on"}{" "}
                            </b>
                            : {product.startDate}
                          </ProductSize>
                          <CartLine>
                            <b>Return by: </b>
                            {product.endDate}
                          </CartLine>
                        </Details>
                      </Link>

                      <PriceDetail>
                        <ProductPrice>
                          £{product.price.toFixed(2)} per day
                        </ProductPrice>
                        <ProductAmountSmall>
                          Delivery method:{" "}
                          {product.deliveryMethod === "delivery"
                            ? `${
                                product?.postageCost
                                  ? `£${product?.postageCost}`
                                  : "Free"
                              } postage`
                            : "collection"}
                        </ProductAmountSmall>

                        <ProductAmountContainer
                          onClick={() => decQuantity(product)}
                        >
                          <DeleteIcon style={{ cursor: "pointer" }} />{" "}
                          <span style={{ fontSize: "0.7em" }}>Remove</span>
                        </ProductAmountContainer>
                      </PriceDetail>
                    </Product>
                  </>
                ))}
              </Info>
            </Summary>
          </Bottom>
        </Wrapper>
        <Footer />
      </Container>
    </>
  );
};

export default Cart;
